import {
  SelectedProductProductID,
  SelectedProductProductNanoID,
  SelectedProductProductName,
  SelectedProductProductPreviewModelFile,
  SelectedProductProductPreviewModelName
} from '../selectedProducts/selectedProductsTypes';
import { words } from '../../locales/keys';
import { I18nText } from '../../types';

export interface ComposeSelectedProductsModalButtonSelectedProduct {
  product: {
    id: SelectedProductProductID;
    nanoId: SelectedProductProductNanoID;
    name: SelectedProductProductName;
    previewModel: {
      file: SelectedProductProductPreviewModelFile;
      name: SelectedProductProductPreviewModelName;
    } | null;
  };
}

// Kept as a standalone copy rather than importing from the modelViewers
// domain — composer stays self-contained with no cross-module dependency.
export const enum ComposerUnits {
  CM = 'cm',
  IN = 'in'
}

export const composerUnitsConfiguration: Record<
  ComposerUnits,
  { i18nLabel: I18nText; multiplier: number }
> = {
  [ComposerUnits.CM]: { i18nLabel: words.units.cm, multiplier: 1 },
  [ComposerUnits.IN]: { i18nLabel: words.units.in, multiplier: 0.393701 }
};

export const enum ComposerAspectRatioValue {
  AUTO = 'auto',
  CUSTOM = 'custom',
  RATIO_16_9 = '16 / 9',
  RATIO_4_3 = '4 / 3',
  RATIO_1_1 = '1 / 1'
}

export interface ComposerAspectRatioOption {
  value: ComposerAspectRatioValue;
  label?: string;
  i18nLabel?: I18nText;
}
